import * as React from 'react';
import { memo } from 'react';

import { AiOutlineClockCircle } from 'react-icons/ai';
import { MdCheck, MdChevronRight, MdClose } from 'react-icons/md';
import logo1 from '../assets/hero-v3/Frame 7234.svg';
import clock1 from '../assets/hero/clock1.svg';
import girl1 from '../assets/hero/girl1.svg';
import { Label, Label2, Label3, Steps1, Steps2 } from '../consts';
import '../hero.scss';

function Hero2() {
  return (
    <div className='hero1 flex-col gap-12'>
      <div className='px-6 mobileCenter py-0 md:py-5'>
        <div className='flex-1 flex-center'>
          <div className='title'>{Label.label6}</div>
        </div>
      </div>

      {/* BEFORE */}
      <div className='flex-col gap-7'>
        <div className='flex-1 flex-center'>
          <div className='subtitle'>Before</div>
        </div>

        <div className='flex-1 flex-center'>
          <ul className='flex-col md:flex md:flex-row gap-3 flex-nowrap'>
            {Steps1.map((step, idx) => {
              return (
                <>
                  {idx !== 0 && (
                    <div className='flex-center opacity-30'>
                      <MdChevronRight size={30} className='mobileRotate' />
                    </div>
                  )}
                  {step.label === 'timer' ? (
                    <li className='flex-center'>
                      <div className='bg-landing-light rounded-full p-3 flex-center aspect-square w-12'>
                        <AiOutlineClockCircle size={22} className='opacity-70' />
                      </div>
                    </li>
                  ) : (
                    <li className='flex-center'>
                      <div className='bg-landing-light rounded-full py-3 px-6'>
                        <span className='opacity-80'>{step.label}</span>
                      </div>
                    </li>
                  )}
                </>
              );
            })}
          </ul>
        </div>

        <div className='px-4 md:px-44'>
          <div className='flex flex-col md:flex-row gap-7 md:gap-3 p-7 md:px-14 bg-light2 border border-gray-200 rounded-3xl'>
            <div className='flex-none flex-center md:w-[35%]'>
              <img src={clock1} className='w-[13.6rem]' />
            </div>
            <div className='flex-1 flex-center-y md:pl-24'>
              <div className='flex-1 flex-col gap-4'>
                {Label2.map((item) => {
                  return (
                    <div key={item.label} className='flex gap-3'>
                      <span className='bg-[#E6E9F5] flex-center rounded-full w-6 h-6'>
                        <MdClose size={13} color='#737580' />
                      </span>
                      <div className='opacity-90'>{item.label}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* AFTER  */}
      <div className='flex-col gap-7'>
        <div className='flex-1 flex-center'>
          <div className='subtitle'>After</div>
        </div>

        <div className='flex-1 flex-center'>
          <ul className='flex-col md:flex md:flex-row gap-3 flex-nowrap text-white'>
            {Steps2.map((step, idx) => {
              return (
                <>
                  {idx !== 0 && (
                    <div className='flex-center opacity-30 text-black'>
                      <MdChevronRight size={30} className='mobileRotate' />
                    </div>
                  )}
                  {step.label === 'timer' ? (
                    <li className='flex-center'>
                      <div className='bg-badge1 rounded-full p-3 flex-center aspect-square w-12'>
                        <img src={logo1} />
                      </div>
                    </li>
                  ) : (
                    <li className='flex-center'>
                      <div className='bg-badge1 rounded-full py-3 px-6'>
                        <span className='opacity-80'>{step.label}</span>
                      </div>
                    </li>
                  )}
                </>
              );
            })}
          </ul>
        </div>

        <div className='px-4 py-6 md:py-0 md:px-44'>
          <div className='flex flex-col md:flex-row gap-7 md:gap-3 p-7 md:px-14 bg-light2 border border-gray-200 rounded-3xl'>
            <div className='flex-none flex-center md:w-[35%]'>
              <img src={girl1} className='w-[13.6rem]' />
            </div>
            <div className='flex-1 flex-center-y md:pl-24'>
              <div className='flex-col gap-4'>
                {Label3.map((item) => {
                  return (
                    <div key={item.label} className='flex gap-3'>
                      <span className='bg-[#E6E9F5] flex-center rounded-full w-6 h-6'>
                        <MdCheck size={13} color='#737580' />
                      </span>
                      <div className='opacity-90'>{item.label}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(Hero2);
